import { Component, EventEmitter, Output } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-customer-eligibility-completion',
    templateUrl: './customer-eligibility-completion.component.html',
    styleUrls: ['./customer-eligibility-completion.component.scss'],
    standalone: false
})

export class CustomerEligibilityCompletionComponent extends CfetBaseComponent {

  @Output() showCancelModal = new EventEmitter<any>();
  @Output() signupDoneStatus = new EventEmitter<any>();
  signupComplete: any;

  constructor() { super(); }

  cancelsignupCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

  signup(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.signupComplete = true;
      this.signupDoneStatus.emit(true);
    }
  }

}
